  import { endpoints } from "@app/api/apis";
  import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
  import { useAppDispatch, useAppSelector } from "@app/store/hooks";
  import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
  import {MagnifyingGlass,Plus,ClockCounterClockwise,FunnelSimple, Info} from '@sharedComponents/Icons/Icons';

  import axios from "axios";
  import { useEffect, useState, useCallback, useMemo } from "react";
  import { ActivityIndicator, Dimensions, FlatList, Platform, ScrollView, TouchableOpacity, View,StyleSheet, Image } from "react-native";
  import PleadegedAssetInfo from "../PleadgeMF/PleadegedAssetInfo";
  import Button from "@app/sharedComponents/Button/Button";
  import InputText from "@app/sharedComponents/TextInput/TextInput"
  import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
  import LottieView from 'lottie-react-native';
  import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
  import LinearGradient from "react-native-linear-gradient";
  import Modal from "react-native-modal"
  import { addCommasToNumber, truncateToThreeDecimals } from "@app/utils";
  import VerificationOTP from "@app/sharedComponents/VerificationOTP/VerificationOTP";
  import TextField from "@app/sharedComponents/TextFiled/TextField";
  import FilterComponent from './FilterComponent';
  import ConfirmUnpledgeBody from './ConfirmUnpledgeBody';
  import { formatIndianCurrency } from "@app/utils/utility";
  import TooltipComp from '@app/sharedComponents/Tooltip/Tooltip';
  import SystemError from "../../../assets/Icons/SystemErrorIcon";
  import TataLogo from "../../../assets/Icons/TataLogo";
  import BajajLogo from "../../../assets/Icons/BajajLogo";
  import DSPLogo from "../../../assets/Icons/DSPLogo";
  import handleApiErr from "@app/helper/handleApiErr";
  import { showErrorSheet } from "@app/store/slices/errorSlice";
import { LENDER_ID } from "@app/types/regix";
import ROUTE from "@app/navigationApp/routes";
const screenWidth = Dimensions.get('window').width;

  const RemovePledge =({navigation})=>{
      const userDetails = useAppSelector((state) => state.auth.userDetails);
      const assetDetails = useAppSelector((state) => state.auth.assetData);
      const creditInfo = useAppSelector((state) => state.auth.creditDetails);
      const dispatch = useAppDispatch()

      const [assetList,setAssetList] = useState([]);
      const [isUpdateButtonActive,setIsUpdateButtonActive] = useState(false);
      const [isAssetListLoading,setIsAssetListLoading] = useState(true);
      const [isTotalOutstandingFetched,setIsTotalOutstandingFetched] = useState(false);
      const [showLimitAdjuststedModal,setShowLimitAdjustedModal] = useState(false)
      const [itemIndex,setItemIndex] = useState(0)
      const [isPledgeLimitFull,setPledgeLimitFull] = useState(false)
      const [isButtonLoading,setIsButtonLoading] = useState(false)
      const [editedItem,setEditedItem] = useState({})
      const [editValue,setEditValue] = useState('')
      const [resendPayload,setResendPayload] = useState({})
      const [isPledgingSuccess,setIsPledgingSuccess] = useState(false)
      const [successLottie,setSuccessLottie] = useState({})
      const [filteredAssetList,setFilteredAssetList] = useState([]);
      const [tempFilteredAssetList,setTempFilteredAssetList] = useState([]);
      const [showConfirmationPage,setShowConfirmationPage] = useState(false)
      const [filtersSections, setFiltersSections] = useState([]);
      const [showAmountEditModal, setShowAmountEditModal] = useState(false);
      const [filteredList , setFilteredList] = useState([]);
      const [checkedFilters,setCheckedFilters] = useState([]);
      const [serachQuery,setSearchQuery] = useState('');
      const [selectedPledgedList, setSelectedPledgedList] = useState([]);
      const [activeFilter,setActiveFilter] = useState('')
      const [limitSum,setLimitSum] = useState(0);
      const [creditSum,setCreditSum] = useState(0);
      const [showFilter, setShowFilter] = useState(false);
      const [showInfoBox, setShowInfoBox] = useState(false);
      const [showToolTip, setShowToolTip] = useState(false);

      const [actualLimit, setActualLimit] = useState(0);
      const [actualFund, setActualFund] = useState(0);
      const [boxIndex, setBoxIndex] = useState(0);
      const [uniqueIsInCode, setUniqueIsInCode] = useState('');
      const [limitFull, setLimitFull] = useState(false);
      const [maxUnpledgeFund, setMaxUnpledgeFund] = useState(0);
      const [flatlistData, setFlatListData] = useState([]);
      const [pledgedArray, setPledgedArray] = useState([]);
      const [selectedList, setSelectedList] = useState([]);
      const [totalOutStanding, setTotalOutStanding] = useState(0);
      const [totalPledgedFunds,setTotalPledgedFunds]= useState(0);
      const [creditLimit, setCreditLimit] = useState(0);
      const [showUnpledgeOtpModal, setShowUnpledgeOtpModal] = useState(false);
      const [bufferTotalOutstanding, setBufferTotalOutstanding] = useState(0);

      const firebaseParams = useAppSelector((state) => state.firebaseParams);


    const lendingPartnerId = creditInfo?.lendingPartnerId;

      const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient)

      const creditAmount = userDetails.linkedCredits[0].totalDrawingPower

      let eligibleFilters = [];
      let selectedFundForEdit ;

      const logo = (id) => {
        const logoObj ={
        tata: <TataLogo/>,
        bajaj: <BajajLogo/>,
        dsp: <DSPLogo color1={themeColorSet['icon-primary']}/>,
        }
        return logoObj[id]
    }


    
      useEffect(() => {
          fetch(
              'https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json',
              {
                  method: 'GET',
              },
          )
              .then((response) => response.json())
              .then((responseData) => {
                  console.log(responseData);
                  setSuccessLottie(responseData);
              })
              .catch((error) => {
                  console.log(error);
              });
      }, [])
    


      const calculateSumOfAssetPledgedValue = (
          assets: any[]
      ) => {
          let sum = 0;
          let limit = 0
          for (const asset of assets) {
              sum += asset.assetPledgedValue;

          } 
  setTotalPledgedFunds(sum)
      };




      useEffect(() => {
      
          // Filter items from pledgeList based on isin codes present in filteredIsinCodes
          const filteredPledgedArray = filteredAssetList.filter(asset => 
              selectedPledgedList.some(unique_locator => asset.unique_locator.includes(unique_locator))
          );
          
      
          console.log("Filtered Pledged Array", filteredPledgedArray);
      
          let sum = 0;
          let credit = 0;
          
          for (const asset of filteredPledgedArray) {
              sum += asset.assetPledgedValue || 0;  // Ensuring no NaN errors
              credit += asset.assetCurrentLimit || 0;
          }
      
          console.log("Pledged Array", filteredPledgedArray);
          setLimitSum(sum);
          setCreditSum(credit);
          console.log("Credit Sum", credit);
          setPledgedArray(filteredPledgedArray)
      }, [selectedPledgedList]);

      

      const calculateTobeUnPledgedUnits = useCallback((item: any) => {
          const selectedArray = assetList.filter(asset => asset.assetCode === item.assetCode)

          if (Math.floor(selectedArray[0]?.assetPledgedValue) === Math.floor(item?.assetPledgedValue)) {
              return item.assetPledgedUnits;
          }

          return item.assetPledgedValue / item.assetCurrentMarketPrice;
      }, [assetList]);

      const updatedCreditLimit = useMemo(() => 
          creditAmount - creditSum, 
      [creditAmount, creditSum]);

      const addFundsToArray = (item: Object, unique_locator: string) => {
          let tArray = [...pledgedArray]; // Create a new array referencef
      
          console.log('PLEDGED ARRAY',pledgedArray)
          const indexes = pledgedArray.findIndex(asset => asset.unique_locator === unique_locator);
          const mainListIndex = assetList.indexOf(item);
      
          if (indexes > -1) {
              let newData = [...filteredAssetList];
              const index = newData.findIndex((items) => items.unique_locator === unique_locator);

              if (newData[index]?.assetOldValue) {
                  newData[index] = {
                      ...newData[index],
                      assetPledgedValue: newData[index].assetOldValue,
                      assetCurrentLimit: newData[index].assetOldValue * newData[index].assetLtv,
                  };
                  setFilteredAssetList(newData);
                  setTempFilteredAssetList(newData);
              }
      
              tArray.splice(indexes, 1); // Remove item (immutably)
              setLimitFull(false);
              setShowInfoBox(false);
          } else {
              if (limitFull) {
                  // alert("Limit full");    
                  setPledgeLimitFull(true)
                  return;
              }
              tArray = [...tArray, item]; // Append new item immutably
          }

          if (Math.floor(creditAmount - bufferTotalOutstanding) < 0) {
              return;
          }

          setPledgedArray(tArray); // Correctly update state with a new reference
      
          let sum = 0;
          let limit = 0;
      
          for (const asset of tArray) {
              // creditAmount = totalDrawingPower
              // totalOutstanding is powered by Foreclosure API
              // limit = running sum
              console.log("DATA RECEVIED IS" , creditAmount , limit + asset.assetCurrentLimit, bufferTotalOutstanding)

              if (creditAmount - (limit + asset.assetCurrentLimit) > bufferTotalOutstanding || totalOutStanding <= 0) {
                  sum += Math.floor(asset.assetPledgedValue * 100) / 100;
                  limit += asset.assetCurrentLimit;
                  setShowInfoBox(false);
              } else {
            
      
                  let newData = [...assetList];
                  const index = newData.findIndex((items) => items.unique_locator === unique_locator);
      
                  newData[index] = {
                      ...newData[index],
                      assetCurrentLimit: Math.floor(creditAmount - limit - bufferTotalOutstanding),
                      assetPledgedValue: Math.floor((creditAmount - limit - bufferTotalOutstanding) / newData[index].assetLtv),
                      assetOldValue: newData[index].assetPledgedValue,
                  };

                  setFilteredAssetList(newData);
                  setTempFilteredAssetList(newData);
                  // let tempArray = pledgedArray
                  // tempArray.push(newData[index])
                  // setPledgedArray(tempArray);


                  sum += Math.floor(((creditLimit - limit - bufferTotalOutstanding) / newData[index].assetLtv) * 100) / 100;
                  limit += Math.floor((creditLimit - limit - bufferTotalOutstanding) * 100) / 100;
                  setLimitFull(true);
                  setMaxUnpledgeFund(sum);
                  setActualLimit(asset.assetCurrentLimit)
                  setBoxIndex(index)
                  setUniqueIsInCode(asset.isinCode)
                  break;
              }
          }


          let pledgedList = [...selectedPledgedList]; // Ensure immutability
          const index = pledgedList.indexOf(item.unique_locator);
          if (index > -1) {
              pledgedList.splice(index, 1);
          } else {
              pledgedList.push(item.unique_locator);
          }




          console.log("SELECTED PLEDGE LIST",pledgedList)
          setSelectedPledgedList(pledgedList); // Correctly update state

          
      };
      


      const fetchpleadedList = ()=>{
          console.log("PLeaded list ", assetDetails)

          setAssetList(assetDetails)
          setFilteredAssetList(assetDetails)
          setTempFilteredAssetList(assetDetails)
          const equityFunds = assetDetails?.filter(item => item?.assetSubType === "EQUITY") || [];

          setFilteredList(equityFunds)
      }



      const fetchTotalOutstanding = () => { 
          const url = endpoints.getForeclosureDetails + userDetails?.linkedCredits[0]?.creditId;
          const lenderName = userDetails?.linkedCredits[0]?.lendingPartnerId;
          const extraOutstandingBufferBajaj = Number(firebaseParams?.extra_outstanding_buffer || "0");
          const extraOutstandingBufferDsp = Number(firebaseParams?.extra_outstanding_buffer_dsp || "0");
          axios.get(url).then((res)=>{
            const netPayable = lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? res?.data?.netPayable : res?.data?.totalDue;
            const extraBufferBajaj = (100 + extraOutstandingBufferBajaj)/100;
            const extraBufferDsp = (100 + extraOutstandingBufferDsp)/100;
            const extraBufferMultiplier = lenderName?.toLowerCase() === LENDER_ID?.BAJAJ?.toLowerCase() ? extraBufferBajaj : lenderName?.toLowerCase() === LENDER_ID?.DSP?.toLowerCase() ? extraBufferDsp : 1;
            const bufferTotalOutstanding = netPayable * extraBufferMultiplier;
            setTotalOutStanding(netPayable);
            setBufferTotalOutstanding(bufferTotalOutstanding);
            setIsTotalOutstandingFetched(true)
          });
      }

      const handleSearch = (searchQuery: string) => {
          setSearchQuery(searchQuery);
          const filtered = tempFilteredAssetList.filter((asset: any) =>
              (asset.assetName as string).toLowerCase().includes(searchQuery.toLowerCase())
          );

          setFilteredAssetList(filtered);
          
      };

      const onCheckBoxPressed = (assetItem: any) => {
          addFundsToArray(assetItem, assetItem.unique_locator);
          console.log('ASSET ITEM',assetItem)
      };


      
      


      const segregateFilters = () => {
              assetList.map((item) => {
                  if (
                      eligibleFilters.includes(item.assetSubType)
                  ) {
                      console.log("INSIDE IF",item.assetSubType)
                      // Do nothing basically
                  } 
                  else { 
                      console.log("INSIDE ELSE",item.assetSubType) 
                      eligibleFilters.push(item.assetSubType);
                  }
              });
      

              setFiltersSections(eligibleFilters);

              setActiveFilter(eligibleFilters[0]);

              setIsAssetListLoading(false)

              calculateSumOfAssetPledgedValue(assetList)
                      
      }



      // useEffect(() => {
      //     const equityFunds = filteredAssetList.filter(item => item.assetSubType === "EQUITY");

      //       setFilteredList(equityFunds)
        
      // },[activeFilter])


      useEffect(()=> {

          console.log('FILTERS',filtersSections)
      },[filtersSections])

      useEffect(()=>{
          if(assetList && assetList.length > 0){
            segregateFilters()
          }
      },[assetList]
      )





      useEffect(()=>{
          fetchpleadedList()
          fetchTotalOutstanding()
      },[])


      const closeBottomSheet = () => {
          setShowFilter(false)
          setShowUnpledgeOtpModal(false)
      }


      const onFilterCheckBoxPressed = (filterItem: any) => {

          // @ts-ignore
          setCheckedFilters(prevCheckedFilters => 
              prevCheckedFilters.includes(filterItem) 
                  ? prevCheckedFilters.filter(item => item !== filterItem) 
                  : [...prevCheckedFilters, filterItem]
          );
    
        }




      const updateListWithEditedAmount =() => {
          if (editValue !== "" && isUpdateButtonActive) {
              let newData = [...filteredAssetList]; // Shallow copy of array
              let pledgedData = [...pledgedArray]; // Shallow copy of array
              const itemIndex = filteredAssetList.findIndex(asset => asset.isinCode === editedItem.isinCode);

          
              let totalUnitsToBePledged = parseInt(editValue) / newData[itemIndex].assetCurrentMarketPrice;
          
              // Create a new object instead of modifying the original
              newData[itemIndex] = {
                  ...newData[itemIndex],
                  preEditAssetValue: newData[itemIndex].assetPledgedValue, 
                  assetPledgedValue: Math.floor(parseInt(editValue)),
                  assetCurrentLimit: totalUnitsToBePledged * newData[itemIndex].assetLtv * newData[itemIndex].assetCurrentMarketPrice
              };
          
          
              const indexes = pledgedData.findIndex(asset => asset.isinCode === editedItem.isinCode);
              if (indexes > -1) {
                  let sum = 0;
                  let limit = 0;
          
                  // Create a new object instead of modifying the existing one
                  pledgedData[indexes] = {
                      ...pledgedData[indexes],
                      assetPledgedValue: Math.floor(parseInt(editValue)),
                      assetCurrentLimit: totalUnitsToBePledged * newData[itemIndex].assetLtv * newData[itemIndex].assetCurrentMarketPrice
                  };
          
                  for (const asset of pledgedData) {
                      sum += Math.floor(asset.assetPledgedValue * 100) / 100;
                      limit += asset.assetCurrentLimit;
                  }
                  setLimitSum(sum);
                  setCreditSum(limit);
              }

           

              console.warn("NEW DATA", newData);
          
              setFilteredAssetList(newData);
              setTempFilteredAssetList(newData);
              setPledgedArray(pledgedData);
              setShowAmountEditModal(false);
        }
      }
  

      const renderEditAmount = () => {
  return(
      <Modal
      onBackdropPress={() => {
          setShowAmountEditModal(false)
          setIsUpdateButtonActive(true)
      }}
      animationOutTiming={500}
      animationInTiming={500}
      backdropColor={'transparent'}
      customBackdrop={
          <TouchableOpacity
              activeOpacity={1}
              onPress={() => {
                  setShowAmountEditModal(false)
              }}
              style={{
                  width: 504,
                  height: '100%',

                  backgroundColor: '#25252599',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  marginTop: Platform.OS === 'web' ? 82 : 0,
              }}
          ></TouchableOpacity>
      }
      isVisible={showAmountEditModal}
      animationIn={'zoomInDown'}
      animationOut={'zoomOutUp'}

  >
      <ThemedView style={{ 
          backgroundColor: 'white',
          padding: 16,
          justifyContent: 'center',
          borderRadius: 8,
          borderColor: 'rgba(0, 0, 0, 0.1)',
          minWidth: 300,
          paddingTop: 38,
          ...(Platform.OS === "web" && { alignSelf: 'center' }),
      }}>
      <TextField keyboardType={'number-pad'}
                                style={Platform.OS !== 'web' && {minWidth: 276}}
                                value={editValue !== "" ? Math.floor(parseInt(editValue)).toString() : editValue}
                                onChangeText={(text) => {
                                  console.log('Selected fund for edit', selectedFundForEdit)
                                    if(parseInt(text) > parseInt(Math.max(editedItem.assetPledgedValue,editedItem?.preEditAssetValue??0)) ){

                                    }
                                    else {
                                      
                                      const isValid = /^[0-9]*$/.test(text);

                                      if (isValid) {
                                        const numericValue = parseInt(text || '0');
                                        if (numericValue <= parseInt(Math.max(editedItem.assetPledgedValue,editedItem?.preEditAssetValue??0))) {
                                        
                                          if(parseInt(text)< 4){
                                            setIsUpdateButtonActive(false)
                                              
                                          }
                                          else {
                                            setIsUpdateButtonActive(true)
                                          }
                                          setEditValue(text);
                                        }
                                      }
                                    }
                                }
                                } 
                                holder={"Update amount"} label={"Update amount"}
                      />



                      <Button  type= {isUpdateButtonActive ? 'SOLID' : 'OUTLINED'}   overRideStyle={{marginTop :16}} label="Update amount" handlePress={()=> {
                          updateListWithEditedAmount()

                      }}/>

                    

      </ThemedView>

  </Modal>
  )

      }

  const onApplyFilterPressed  = () => {


      if(checkedFilters.length !== 0){
      const filteredAssets = assetList.filter(
          asset => checkedFilters.some(checked => checked.unique_locator === asset.unique_locator )
        );


        setFilteredAssetList(filteredAssets)
        setTempFilteredAssetList(filteredAssets)
        
      }
      else {
          setFilteredAssetList(assetList)
          setTempFilteredAssetList(assetList)
      }
      setShowFilter(false)

  }


  const onEditAmountPressed =(assetItem: any, index: number) => {

      console.log('ASSET ITEM',assetItem, index)
      selectedFundForEdit = assetItem
      setEditValue(selectedFundForEdit.assetPledgedValue)
      setEditedItem(assetItem);
      setItemIndex(index)
      setShowAmountEditModal(true)
  }



  const renderInfoModal = () => {
      return (
        <BottomSheetContainer
          isVisible={showInfoBox}
          close={()=>{
              setShowInfoBox(false)
          }}
          closeOnBackdropPress={true}
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
        >
          <ThemedView p="lg">
            <ThemedText variant ="h5s"color="text-primary">
              Updated credit limit
            </ThemedText>
    <ThemedView style={{ marginTop :24,borderRadius: 8, borderWidth: 1, borderColor: '#E4E7EC', paddingHorizontal: 16, paddingBottom: 16}}>
            <ThemedView marginTop='lg' >
              <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                <ThemedText variant="b3s" color="text-secondary">
                  Credit limit against portfolio
                </ThemedText>
                <ThemedText variant="b3r" color="text-secondary">
                  ₹{formatIndianCurrency(creditAmount)}
                </ThemedText>
              </ThemedView>
    
              <ThemedView flexDirection="row" justifyContent="space-between">
                <ThemedView flexDirection="row" alignItems="center">
                  <ThemedText variant="b3r" color="text-secondary">
                    Selected limit for unpledging
                  </ThemedText>
                  <ThemedPressable onPress={() => {}}>
                    {/* Add an icon or some action here if needed */}
                  </ThemedPressable>
                </ThemedView>
                <ThemedText variant="b3r" color="text-secondary">
                  ₹{formatIndianCurrency(creditSum)}
                </ThemedText>
              </ThemedView>
            </ThemedView>


            <ThemedView my="lg" backgroundColor="border-secondary" height={1} width="100%" />



            <ThemedView>
              <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                <ThemedText variant="b3s" color="text-secondary">
                Updated credit limit against portfolio
                </ThemedText>
                <ThemedText variant="b3r" color="text-secondary">
                  ₹{formatIndianCurrency(updatedCreditLimit)}
                </ThemedText>
              </ThemedView>
    
              <ThemedView flexDirection="row" justifyContent="space-between">
                <ThemedView flexDirection="row" alignItems="center">
                  
                  <ThemedText variant="b3r" color="text-secondary">
                  Max loan amount sanctioned
                  </ThemedText>
                  <ThemedPressable onPress={()=>setShowToolTip(!showToolTip)}>
                        <Info size={16} style={{marginLeft :5}}/>
                        {showToolTip &&
                          <TooltipComp 
                              title={"This is the max sanctioned loan amount approved as per your loan agreement, it can be revised by doing another agreement by increasing your limit"}
                          />
                        }
                      </ThemedPressable>
                </ThemedView>
                <ThemedText variant="b3r" color="text-secondary">
                  ₹{formatIndianCurrency(userDetails?.linkedCredits[0].approvedCreditAmount)}
                </ThemedText>
              </ThemedView>
            </ThemedView>
    
            <ThemedView my="lg" backgroundColor="border-secondary" height={1} width="100%" />
    
            <ThemedView flexDirection="row" justifyContent="space-between">
              <ThemedText variant="b3s" color="text-primary">Updated credit limit</ThemedText>
              <ThemedText variant="b3s" color="text-emphasis-secondary">
                ₹{formatIndianCurrency(updatedCreditLimit)}
              </ThemedText>
            </ThemedView>
            </ThemedView>
          </ThemedView>
        </BottomSheetContainer>
      );
    };


  const renderConfirmationBody = () => {
      return (
        <>
          <PageHeaders label="Confirm unpledge" navigation={navigation} pageName={"RemovePledge"} />
        <ScrollView style={{backgroundColor:themeColorSet["bg-surface-primary"]}}>
          <ThemedView alignItems="center" padding="lg" justifyContent="space-between" backgroundColor="bg-fill-secondary" height={50} flexDirection="row">
            <ThemedText variant="b4r">Lending partner</ThemedText>
            {logo(lendingPartnerId.toLowerCase())}

          </ThemedView>
    
          <ThemedText margin="lg" variant="h5s" >Unpledged MF details</ThemedText>
          <ThemedView
            borderColor='border-primary'
            style={{
              marginBottom: 16,
              // borderColor: '#E4E7EC',
              borderWidth: 1,
              borderRadius: 8,
              marginHorizontal: 16,
              backgroundColor: themeColorSet['bg-fill-primary'],
            }}
          >
            <ThemedView style={{ paddingHorizontal: 16, paddingTop: 16 }}>
              <ThemedText variant="b3r">
                Selected portfolio
              </ThemedText>
            </ThemedView>
    
            <ThemedView style={{ flexDirection: 'row', marginTop: 5, paddingHorizontal: 16, alignItems: 'baseline' }}>
            <ThemedText variant="l5" color="text-primary">
                {`₹`}
              </ThemedText>
              <ThemedText variant="h5s" color="text-primary">
                {`${formatIndianCurrency(Math.floor((limitSum)))}`}
              </ThemedText>
    
              <ThemedView>
                <ThemedText variant="b3r">
                  {` out of ₹${formatIndianCurrency(Math.floor((totalPledgedFunds)))}`}
                </ThemedText>
              </ThemedView>
            </ThemedView>
    
            <ThemedView style={{ height: 1, width: '100%', marginTop: 12, marginBottom: 12 }} backgroundColor='border-primary'/>
            <ThemedView style={{ paddingHorizontal: 16 }}>
            <ThemedText variant="b3r">
                Selected credit limit
              </ThemedText>
            </ThemedView>
    
            <ThemedView style={{ flexDirection: 'row', marginTop: 5, paddingHorizontal: 16 }}>
            <ThemedText variant="l5" color="text-primary">
                {`₹`}
              </ThemedText>
            <ThemedText variant="h5s" color="text-primary">
                {`${formatIndianCurrency(Math.floor((creditSum)))}`}
              </ThemedText>
            </ThemedView>
    
            <ThemedView style={{ height: 1, width: '100%', marginTop: 12 }} backgroundColor='border-primary' />
              <ThemedView padding="lg">
              <ThemedPressable  eventName="EDIT_SELECTED_FUNDS_BUTTON"   onPress={()=> {setShowConfirmationPage(false)}}>
              <ThemedText  color="text-action-primary" variant="b3s">{"Edit >"}</ThemedText>
              </ThemedPressable>
              </ThemedView>
          </ThemedView>


          <ThemedView height={20} backgroundColor="bg-surface-page"></ThemedView>
          <ThemedView padding="lg">
        <ThemedText variant="h5s">Updated credit limit</ThemedText>
          <ThemedView flexDirection="row" marginTop="lg" >
          <ThemedText variant="l5" color="text-emphasis-secondary" >
                {`₹`}
              </ThemedText>
          <ThemedView  alignItems="center"flexDirection="row">

          <ThemedText variant="h5s"  color="text-emphasis-secondary">{`${formatIndianCurrency(updatedCreditLimit)}`}
          </ThemedText>
              <ThemedPressable ml="sm" mt="2xs" onPress={()=>{setShowInfoBox(true)}} style={{position: 'relative', bottom: 2}}>
                <Info size={16} color={themeColorSet['icon-primary']}/>
              </ThemedPressable>
          </ThemedView>

  </ThemedView>
          </ThemedView>
          <ThemedView height={20} backgroundColor="bg-surface-page"></ThemedView>
          <ThemedView padding="lg">
        <ThemedText variant="h5s">Process to remove the pledge</ThemedText>
          <ThemedText variant="b3r" marginTop="lg">Note: Your request to remove pledge will be completed in 2-3 working days. This action can't be undone.</ThemedText>
          </ThemedView>
          </ScrollView>
          <ThemedView p="lg" backgroundColor="bg-fill-primary" borderTopWidth={1} borderColor="border-primary">
              

              <Button
                  label={'Confirm and get OTP'}
                  buttonLoader={isButtonLoading}
                  handlePress={()=>{ 
                      setIsButtonLoading(true)

          triggerUnpledgeOtp()

                  }}
              />

          </ThemedView>
          {renderUnpledgeOtp()}
          {renderInfoModal()}

        </>
      );
    };


    const renderPledgeLimitFull =() => {
      return(
          <BottomSheetContainer
          isVisible={isPledgeLimitFull}
          close={() =>{                   
              setPledgeLimitFull(false)
          }}
          closeOnBackdropPress={true}
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
          containerStyle={{ backgroundColor: '#fefefe' }}
      > 
      
      <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">

      <SystemError  size={32} />

                  <ThemedText marginTop="lg" variant="h5s">Max unpledge limit reached</ThemedText>
                  <ThemedView alignContent="center" alignItems="center" width={'100%'} marginTop="sm" backgroundColor={'bg-fill-info'} borderRadius="sm" padding="lg" >
                  <ThemedText marginTop="sm" variant="b3r">{"You cannot select more funds for un-pledging"}</ThemedText>
                  </ThemedView>

                  <Button overRideStyle={{marginTop : 24}} type="SOLID" handlePress={()=> {
                      setPledgeLimitFull(false)
                  }} label={"Okay,Got it"}/>
                      


          </ThemedView>
      
      </BottomSheetContainer>
      )

  }
    const renderPledgingSuccessView = () => {

      return(
          <ThemedView alignContent="center" justifyContent="center" alignItems="center" padding="lg">
      {successLottie && <LottieView
                      source={successLottie}
                      style={{width: 70, height: 'auto'}}
                      autoPlay={true}
                      loop={true}
                  />}

                  <ThemedText marginTop="lg" variant="h5s">Unpledge request raised successfully</ThemedText>
                  <ThemedText variant="b3r" textAlign="center">{"RTAs may take 3-5 business days to\nremove pledge from your portfolio"}</ThemedText>
                  <Button overRideStyle={{marginTop : 24}} type="OUTLINED" handlePress={()=> {
                    navigation.navigate(ROUTE.DASHBOARD_SCREEN)
                  }} label={"Continue"}/>

          </ThemedView>
      )
    }


    const renderUnpledgeOtp = () => {
      return(
          <BottomSheetContainer
          isVisible={showUnpledgeOtpModal || isPledgingSuccess}
          close={closeBottomSheet}
          closeOnBackdropPress={true}
          onClose={() => {setShowUnpledgeOtpModal(false) 
            }
        
        }
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
          containsTextInput
          containerStyle={{ backgroundColor: '#fefefe' }}
      > 
        { isPledgingSuccess ?  renderPledgingSuccessView() :   
        <VerificationOTP 
              heading="Verify your account"
              otpType="PHONE_NUMBER"
              otpSentTo={userDetails?.user?.phoneNumber}
              otpDigitCount={6}
              resendUrl={endpoints?.createRevocation}  
              verifyUrl={endpoints?.verifyRevocation}
              attributeKeyToVerify={'phoneNo'}
              isErrorReceived={()=> setShowUnpledgeOtpModal(false)} 
              
              attributeValueToVerify={userDetails?.user?.phoneNumber}
              onClose={()=> 
                setShowUnpledgeOtpModal(false) }
              onVerificationSuccess={()=> {
                  setIsPledgingSuccess(true)
              }}
              currentStep={"UNPLEDGE_PORTFOLIO"}
              uniqueIdentifier={userDetails?.linkedCredits[0]?.creditId}
              apiPayload={resendPayload}
              resendApiMethod={"POST"}          
              />
               }
      </BottomSheetContainer>
      )
    }


  const triggerUnpledgeOtp = () =>{

      
      const updatedPledgedArray = pledgedArray.map((item) => {
          console.log(Object.getOwnPropertyDescriptor(item, 'tobeUnPledgedUnits'));
      
          const calculatedValue = calculateTobeUnPledgedUnits(item);
          console.log(`Before:`, item.tobeUnPledgedUnits); 
          console.log(`Calculated Value:`, calculatedValue);
      
          return {
              ...item, // Clone the object to avoid modifying the original
              tobeUnPledgedUnits: calculatedValue
          };
      });
      
  const url = endpoints.createRevocation 

  const roundedData =updatedPledgedArray.map(item => ({
      ...item,
      tobeUnPledgedUnits:  parseFloat(truncateToThreeDecimals(item.tobeUnPledgedUnits)) < item.assetPledgedUnits  ?  parseFloat(truncateToThreeDecimals(item.tobeUnPledgedUnits)) : item.assetPledgedUnits
  }));


  const payload = {
      creditId: userDetails?.linkedCredits[0]?.creditId,
      securitiesToRevoke: roundedData
  }

  setResendPayload(payload)

  axios.post(url,payload).then((res)=>{
      setShowUnpledgeOtpModal(true)

    }).catch((err)=>{
      console.log('newApplication',err) 
      if(handleApiErr(err)){
        const { message,header,voltErrorCode } = err?.data;
        dispatch(showErrorSheet({
          isErrorSheetVisible: true,
          errorMessage: message,
          closeOnBackdropPress: true,
          errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
          errorHeading: header,
          btnName:'Ok, got it!',
        }))
      }
    }).finally(()=>{
      setIsButtonLoading(false)
    })
  

  }



  const renderUnpledgeBody = () => {
      return(
          <>
          <PageHeaders
          pageName="RemovePledge"
          label={'Remove pledge from MFs'}
          navigation={navigation}
        />
        <ScrollView
          style={{flex: 1, backgroundColor: themeColorSet['bg-surface-primary'], marginBottom:100}}>
                  <ThemedView p="lg" mb="8xl">
            <ThemedText variant="h5s" color="text-primary">
              Select mutual funds
            </ThemedText>
                      <InputText 
                          showAnimation={false} 
                          value={serachQuery}
              onChangeText={(serachQuery) => handleSearch(serachQuery)}
                          placeHolder="Search mutual funds"
                          showRightAccessory={true}
              rightAccessory={() => (
                <MagnifyingGlass
                  size={20}
                  color={themeColorSet['icon-primary']}
                />
              )}
            />
            <ThemedView
              py="lg"
              pb="2xl"
              backgroundColor="bg-surface-primary"
              // borderTopWidth={1}
              // borderColor="border-primary"
              >
              <ThemedText variant="b3s" color="text-primary" mb="lg">
                Pledged mutual funds
              </ThemedText>
              <ThemedView
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                mb="lg">
                <ThemedText variant="b3r" color="text-primary">
                  {filteredAssetList?.length > 1 ? `${filteredAssetList?.length} MFs` : `${filteredAssetList?.length} MF`}
                </ThemedText>
                <ThemedPressable
                  flexDirection="row"
                  alignItems="center"
                  onPress={() => {
                    setShowFilter(true);
                  }}>
                  <ThemedText variant="b3r" color="text-primary" mr="xs">
                    Filter
                  </ThemedText>
                  <FunnelSimple size={16} color={themeColorSet['icon-primary']} />
                          </ThemedPressable>
                      </ThemedView>
              <ThemedView
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center">
                <ThemedText variant="b4r" color="text-secondary">
                  Mutual fund
                </ThemedText>
                <ThemedText variant="b4r" color="text-secondary">
                  Fund value
                </ThemedText>
                      </ThemedView>
              <ThemedView
                height={1}
                backgroundColor="border-primary"
                width="100%"
                my="sm"
              />

                {filteredAssetList?.length === 0  ? 
                <ThemedView justifyContent="center" alignItems="center" mt="2xl" flex={1}>
                  <Image source={{ uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_investment_1.png'}}  style={{width: 140, height: 140}} />
                  <ThemedText variant="b3r" color="text-secondary" mt="sm" mb="2xl">No results found</ThemedText>
                </ThemedView>
                :(isAssetListLoading || !isTotalOutstandingFetched)  ? <ThemedView>
                 <ActivityIndicator>

                 </ActivityIndicator>
                </ThemedView> :  filteredAssetList.map((assetList, index) => (
                <PleadegedAssetInfo
                  key={index}
                  position={index}
                  asset={assetList}
                  showLimitFullWarning={index === boxIndex && limitFull}
                  isEdit={true}
                  onCheckboxPressed={onCheckBoxPressed}
                  pledgedList={pledgedArray}
                  boxIndex={boxIndex}
                  onEditAmountPressed={onEditAmountPressed}
                />
              ))}
                  </ThemedView>
                  </ThemedView>
              </ScrollView>
        <ThemedView backgroundColor='bg-surface-primary' style={[Platform.OS === 'web' ? ls.webBtn:ls.nativeBtn ]}>
        <ThemedView height={1} width={screenWidth} backgroundColor='border-primary' />
        <ThemedView m="lg">
          <ThemedView
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center">
            <ThemedText variant="b3r" color="text-secondary">
              Selected fund value
            </ThemedText>
            <ThemedText variant="b3s" color="text-primary">{`₹${addCommasToNumber(
              Math.floor(limitSum),
            )}`}</ThemedText>
          </ThemedView>
          <ThemedView
            height={1}
            backgroundColor="border-secondary"
            width={'100%'}
            my="md"
          />
          <ThemedView
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            mb="xl">
            <ThemedText variant="b3r" color="text-secondary">
              Updated credit limit
            </ThemedText>
    
            <ThemedText
              variant="b3s"
              color="text-emphasis-secondary">{`₹ ${addCommasToNumber(
              Math.floor(updatedCreditLimit),
            )}`}</ThemedText>
            
          </ThemedView>

              <Button
                  label={'Continue to un-pledge'}
        handlePress={() => {
          setShowConfirmationPage(true);
        }}
                  disabled={selectedPledgedList.length === 0}
              />
          {renderFilter()}
          {renderEditAmount()}
          {renderPledgeLimitFull()}
              </ThemedView>
        </ThemedView>
          </>
      )
  }
    



  const renderFilter = () =>{
      return(
      <BottomSheetContainer
      isVisible={showFilter}
      close={closeBottomSheet}
      closeOnBackdropPress={true}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      containerStyle={{ backgroundColor: '#fefefe' }}
  >
      <FilterComponent
        {...{
          filtersSections,
          assetList,
          setFilteredList,
          filteredList,
          onFilterCheckBoxPressed,
          checkedFilters,
          onEditAmountPressed,
          setCheckedFilters,
          setFilteredAssetList,
          setTempFilteredAssetList,
          onApplyFilterPressed,
          selectedFilter: activeFilter,
        }}
      />
  </BottomSheetContainer>
      )
  }

      return(
        showConfirmationPage ? renderConfirmationBody() :   renderUnpledgeBody()
      )
  }

  export default RemovePledge;
  const ls = StyleSheet.create({
    nativeBtn:{
      position:'absolute',
      bottom:0,
    },
    webBtn:{
      position: screenWidth>450 ?'absolute':'fixed',
      bottom:0,
      left:0,
      width:'100%'
    }
  });